/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { Gnoment } from 'shared-ui/gnoment';
import get from 'lodash/get';
import { connect } from 'react-redux';
import SingleDatePickerCalendar from '../components/single-date-picker-calendar/SingleDatePickerCalendar';
import { getCurrentTime } from '../utils/utilsNew';
import { isDayBlocked, parsePermitSeasonInfo } from '../utils/availability-utils-scratch';

export function getAvailabilityKey(permitId, divisionId) {
    return `${permitId}-${divisionId}`;
}

export function availabilitySelector(state, permitId, divisionId) {
    if (divisionId) {
        return get(
            state.permit,
            `availabilities[${getAvailabilityKey(permitId, divisionId)}].result`,
            {}
        );
    }
    return state.permit.availability;
}

export function permitSelector(state) {
    return state.permit.result;
}

function mapStateToProps(state, ownProps) {
    const permit = permitSelector(state);
    const aggSeasonRules = state.permit.agg_season_rules;
    const availability = availabilitySelector(state, permit.id, ownProps.divisionId);
    const permitSeasonInfo = parsePermitSeasonInfo(
        aggSeasonRules,
        permit.time_zone,
        ownProps.divisionId,
        permit.rules
    );
    const currentTime = getCurrentTime(ownProps);

    return {
        blockLotteryDates: ownProps.blockLotteryDates,
        permitSeasonInfo,
        availability,
        isDayBlocked: (day) =>
            ownProps.blockFilter(day) ||
            isDayBlocked(
                day,
                permitSeasonInfo,
                currentTime,
                ownProps.blockNonLotteryDates,
                ownProps.blockLotteryDates,
                availability.bools
            ),
    };
}

const propTypes = {
    currentDate: PropTypes.instanceOf(Gnoment),
    blockLotteryDates: PropTypes.bool,
    blockNonLotteryDates: PropTypes.bool,
    divisionId: PropTypes.string,
    blockFilter: PropTypes.func,

    // Passed on to SingleDatePickerCalendar
    onChange: PropTypes.func.isRequired,
    displayAllAvailable: PropTypes.bool,
    calendarOnly: PropTypes.bool,
    selectedDate: PropTypes.shape({}),
    id: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    initialVisibleMonth: PropTypes.instanceOf(Gnoment),
};

const defaultProps = {
    blockFilter: () => false,
};

const SingleDatePickerCalendarContainer = connect(mapStateToProps)(
    SingleDatePickerCalendar
);

SingleDatePickerCalendarContainer.propTypes = propTypes;
SingleDatePickerCalendarContainer.defaultProps = defaultProps;

export default SingleDatePickerCalendarContainer;
